import InicisResultComponent from '@/views/common/InicisResultComponent.vue'

export default [
    {
        path: '/inicisResultComponent',
        component: InicisResultComponent,
        name: 'InicisResultComponent',
    },
]